import { storage } from '../utils/CurrencySelector/ExchangeStorage'

const DEFAULT_FORMAT_LOCALE = 'en-US'

function getFormatLocale(localeOverride?: string) {
  if (localeOverride) {
    return localeOverride
  }

  if (typeof window === 'undefined') {
    return DEFAULT_FORMAT_LOCALE
  }

  return storage.getUserPrefs()?.locale || DEFAULT_FORMAT_LOCALE
}

export function getLastWorkingDay(fromDate = new Date()) {
  const day = fromDate.getDay() // 0 = Sunday, 6 = Saturday
  const resultDate = new Date(fromDate) // clone date

  switch (day) {
    case 1: // Monday
      resultDate.setDate(resultDate.getDate() - 3) // Go back to Friday
      break
    case 0: // Sunday
      resultDate.setDate(resultDate.getDate() - 2) // Go back to Friday
      break
    case 6: // Saturday
      resultDate.setDate(resultDate.getDate() - 1) // Go back to Friday
      break
    default:
      resultDate.setDate(resultDate.getDate() - 1) // Go back one day
  }
  return resultDate
}

export function convertPrice(usdAmount: number, targetCurrency: string) {
  if (typeof window === 'undefined') return usdAmount
  const rates = storage.getRates() || { USD: 1 }
  const rate = rates[targetCurrency] || 1
  return usdAmount * rate
}

export function formatPrice(
  amount: number,
  currency: string,
  fractionDigits: number = 0,
  localeOverride?: string,
) {
  return new Intl.NumberFormat(getFormatLocale(localeOverride), {
    style: 'currency',
    currency,
    maximumFractionDigits: fractionDigits,
    minimumFractionDigits: fractionDigits,
  }).format(amount)
}

export function normalizeCurrencyDisplay(formattedPrice: string, currency: string) {
  if (currency === 'USD') {
    return formattedPrice.replace('US$', '$')
  }

  if (currency === 'EGP') {
    return formattedPrice
      .replace(/^EGP\s*/, 'E£')
      .replace(/\s*EGP$/, ' E£')
  }

  return formattedPrice
}

export function formatCurrencyValue(
  amount: number,
  currency: string,
  fractionDigits: number = 0,
  localeOverride?: string,
) {
  return normalizeCurrencyDisplay(
    formatPrice(amount, currency, fractionDigits, localeOverride),
    currency,
  )
}

export function displayPriceWithCurrency(
  usdAmount: number,
  currency: string,
  fractionDigits: number = 0,
  localeOverride?: string,
) {
  if (currency === 'USD') {
    return formatPrice(usdAmount, 'USD', fractionDigits, localeOverride)
  }

  const convertedAmount =
    typeof window === 'undefined'
      ? usdAmount
      : convertPrice(usdAmount, currency)

  return formatPrice(convertedAmount, currency, fractionDigits, localeOverride)
}
